// extracted by mini-css-extract-plugin
module.exports = {"root":"Map-module--root--2OSU_","marker":"Map-module--marker--miveM"};